import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { FileUploadModule } from 'primeng/fileupload';
import { ProgressBarModule } from 'primeng/progressbar';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { Richiesta } from '../../../models/richiesta.model';
import { TooltipModule } from 'primeng/tooltip';
import { FirebaseStorageService } from '../../../services/firebase-storage.service';
import { RichiesteService } from '../../../services/richieste.service';

@Component({
  selector: 'app-carica-lettera',
  templateUrl: './carica-lettera.component.html',
  styleUrls: ['./carica-lettera.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    FileUploadModule,
    ProgressBarModule,
    ToastModule,
    TooltipModule
  ],
  providers: [MessageService]
})
export class CaricaLetteraComponent implements OnInit {
  @Input() visible: boolean = false;
  @Input() richiesta: Richiesta | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() uploadCompletato = new EventEmitter<{richiestaId: number, nomeFile: string}>();

  caricamentoInCorso: boolean = false;
  progressoCaricamento: number = 0;
  fileSelezionato: File | null = null;
  maxFileSize: number = 5000000; // 5MB

  constructor(
    private messageService: MessageService,
    private logger: NGXLogger,
    private firebaseStorageService: FirebaseStorageService,
    private richiesteService: RichiesteService
  ) {}

  ngOnInit() {}

  onHide() {
    this.visibleChange.emit(false);
    this.resetForm();
  }

  onSelect(event: any) {
    this.fileSelezionato = event.files[0];
    if (this.fileSelezionato) {
      this.messageService.add({
        severity: 'info',
        summary: 'File selezionato',
        detail: `"${this.fileSelezionato.name}" pronto per il caricamento`,
        life: 3000
      });
    }
  }

  onClear() {
    this.fileSelezionato = null;
    this.progressoCaricamento = 0;

   /*  this.logger.info('[CARICA LETTERA] File rimosso d\'utente');
    this.messageService.add({
      severity: 'info',
      summary: 'File rimosso',
      detail: 'Seleziona un nuovo file PDF da caricare',
      life: 3000
    }); */
  }

  onUpload(event: any) {
    // Simulazione caricamento

  }

  confermaCaricamento() {
    if (this.fileSelezionato) {
      const path = `richieste/${this.richiesta?.id}/allegati/${this.fileSelezionato.name}`;

      this.firebaseStorageService.uploadFile(this.fileSelezionato, path).subscribe({
        next: (url: string) => {
          this.richiesteService.caricaLettera(this.richiesta?.id || 0).subscribe({
            next: () => {
              this.uploadCompletato.emit({
                richiestaId: this.richiesta?.id || 0,
                nomeFile: this.fileSelezionato?.name || 'documento.pdf'
              });
              this.onHide();
              this.resetForm();
            }
          });
        },
        error: (error: Error) => {
          this.logger.error(`[CARICA-LETTERA] Errore durante il caricamento del file:`, error);
          this.messageService.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Errore durante il caricamento del file'
          });
          this.onHide();
          this.resetForm();
        }
      });
    }

    this.onUpload(null);
  }

  resetForm() {
    this.fileSelezionato = null;
    this.progressoCaricamento = 0;
    this.caricamentoInCorso = false;
  }
}
